import React from 'react';
import { ZignSecModal } from 'tradera-components/zign-sec-modal/zign-sec-modal';
import draftActions from 'tradera-state/views/syi/actions/draft-actions';
import { useDispatch } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';
import { closeModal } from 'tradera-state/ui/action-creators';

export const SyiZignSecModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslator();
    return (
        <ZignSecModal
            onVerifyComplete={() => {
                dispatch(draftActions.publish(t));
                dispatch(closeModal());
            }}
        />
    );
};

export const syiZignSecModalId = 'syiZignSecModalId';
